import { Section, Reveal, Overline } from "./primitives";
import { CHAPTERS } from "../../data";
import { useSiteContent } from "../../lib/content";
import { motion } from "framer-motion";

export default function About() {
  const { content } = useSiteContent();
  const about = content.about || {};
  const chapters = content.chapters?.length ? content.chapters : CHAPTERS;
  const bullets = [
    ["Mission", about.mission || "Engineer integrated growth for ambitious brands."],
    ["Vision", about.vision || "Become the most trusted growth partner in the region."],
    ["Values", about.values || "Craft, transparency, speed and measurable outcomes."],
  ];

  return (
    <Section id="about">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>{about.overline || "About VYFT"}</Overline>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl tracking-tight leading-tight">
              {about.heading_pre || "A manifesto for "}<span className="text-gradient">{about.heading_gradient || "measurable"}</span>{about.heading_post || " growth."}
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              {about.body || "VYFT began with a simple belief: brands don't need ten agencies, they need one partner accountable for growth. Today we operate as a 360° studio across events, media, branding, technology and performance."}
            </p>
            <div className="mt-8 space-y-4">
              {bullets.map(([k, v]) => (
                <div key={k} className="flex gap-4">
                  <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-gradient" />
                  <p className="text-sm"><span className="font-semibold text-foreground">{k}. </span><span className="text-muted-foreground">{v}</span></p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8 space-y-4">
          {chapters.map((c, i) => (
            <Reveal key={c.no || i} delay={i * 0.1}>
              <motion.div
                whileHover={{ x: 8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="group relative rounded-3xl border border-border/10 bg-card p-8 md:p-10 shimmer-card"
              >
                <div className="flex items-start gap-6">
                  <span className="font-display text-5xl md:text-6xl font-extrabold text-transparent" style={{ WebkitTextStroke: "1.5px hsl(var(--primary))" }}>{c.no || String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight">{c.title}</h3>
                    <p className="mt-3 text-muted-foreground leading-relaxed max-w-2xl">{c.body}</p>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
